interface CohortCampusProps {
  cohort?: string | null;
  campus?: string | null;
}

const CohortCampus = ({ cohort, campus }: CohortCampusProps) => (
  <>
    {cohort && (
      <span data-testid="cohort-campus-cohort">
        Cohort: <span className="font-semibold text-gray-600">{cohort}</span>
      </span>
    )}
    {campus && (
      <span data-testid="cohort-campus-campus">
        Campus: <span className="font-semibold text-gray-600">{campus}</span>
      </span>
    )}
  </>
);

export default CohortCampus;
